import getPageFromLocation from './getPageFromLocation';

export default function getPage() {
  return getPageFromLocation(window.location.pathname);
}
